// extracted by mini-css-extract-plugin
export var root = "index-module--root--fQgxq";
export var description = "index-module--description--Orz8e";
export var blocker = "index-module--blocker--qGnxt";
export var logoLink = "index-module--logoLink--N8qoh";